var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPoolAlpinSupplierBlack = function SvgPoolAlpinSupplierBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1770.4177,
    height: 552.07867,
    viewBox: "0 0 1770.4177 552.07867",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "palo-login-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9819.0002,-2.5e-5 V 4141.0001 H 13279 V -2.5e-5 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.11562506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1146.42,1614.67 c 71,0 104.15,37.85 104.15,118.34 v 700.59 c 0,80.48 -33.15,118.33 -104.15,118.33 H 568.945 V 1614.67 Z M 0.867188,3072.68 H 1155.9 c 492.3,0 658.05,-359.78 658.05,-662.75 v -653.26 c 0,-302.96 -165.75,-662.74 -658.05,-662.74 H 568.945 V 0.410156 H 0.867188 V 3072.68",
    style: {
      fill: "#040606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,552.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3503.1,1609.89 v 823.71 c 0,80.48 -33.1,118.33 -108.9,118.33 h -449.71 c -75.7,0 -104.15,-37.85 -104.15,-118.33 v -823.71 z m -1230.76,809.53 c 0,298.18 179.85,653.26 662.75,653.26 h 473.31 c 492.3,0 658.1,-359.78 658.1,-662.75 V 0.410156 H 3503.1 V 1089.14 H 2840.34 V 0.410156 h -568 V 2419.42",
    style: {
      fill: "#040606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,552.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5224.7,0.410156 c -492.3,0 -662.8,359.780844 -662.8,662.741844 V 3072.68 H 5130 V 639.48 c 0,-80.48 28.4,-118.328 104.1,-118.328 h 932.6 V 0.410156 h -942",
    style: {
      fill: "#040606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,552.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7782.19,521.152 c 71,0 104.15,37.848 104.15,118.328 V 2433.6 c 0,80.48 -33.15,118.33 -104.15,118.33 h -506.56 c -75.7,0 -104.15,-37.85 -104.15,-118.33 V 639.48 c 0,-80.48 28.45,-118.328 104.15,-118.328 z m -1178.79,142 V 2409.93 c 0,302.97 170.45,662.75 662.75,662.75 h 525.44 c 492.38,0 658.05,-359.78 658.05,-662.75 V 663.152 C 8449.64,360.191 8283.97,0.410156 7791.59,0.410156 h -525.44 c -492.3,0 -662.75,359.780844 -662.75,662.741844",
    style: {
      fill: "#040606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,552.13333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11168.6,2815.86 V 2140.91 L 10498,1933.98 v 674.23 l -673.3,-205.84 v 668.77 l 3452.6,1069.93 1.8,-668.18 -2110.5,-657.03",
    style: {
      fill: "#040606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,552.13333)",
    clipPath: "url(#palo-login-clip)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13276.8,2789.71 1.4,-2138.507 v -4.496 c 0,-498.957 -245.4,-646.296844 -747,-646.296844 H 9824.7 V 1727.89 l 673.3,206.09 V 683.563 c 0,-6.29 6.3,-12.583 12.6,-12.583 h 1976.7 c 86.2,0 116.8,44.051 116.8,133.942 V 2582.22",
    style: {
      fill: "#040606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,552.13333)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPoolAlpinSupplierBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pool-alpin-supplier-black.8c59b52b78ce9e2c96bf5fe57ea83e07.svg";